<template>
  <div class="modal-backdrop">
    <div class="popup-content strategy-modal">
      <button class="strategy-modal__close" type="button" @click="$emit('close')">
        ✕
      </button>

      <div class="strategy-card">
        <div class="strategy-panel">
          <div class="strategy-filters">
            <div class="filter-group">
              <label class="filter-label" for="helpfulFilter">Полезность</label>
              <select id="helpfulFilter" v-model="helpfulFilter" class="filter-select">
                <option value="all">Все</option>
                <option value="helpful">Помогло</option>
                <option value="not_helpful">Не помогло</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label" for="savedFilter">Состояние</label>
              <select id="savedFilter" v-model="savedFilter" class="filter-select">
                <option value="all">Все</option>
                <option value="saved">Сохранённые</option>
                <option value="hidden">Скрытые</option>
              </select>
            </div>

            <div class="filter-group">
              <label class="filter-label" for="colorFilter">Цвет</label>
              <select id="colorFilter" v-model="colorFilter" class="filter-select">
                <option value="all">Все</option>
                <option value="red">Красный</option>
                <option value="green">Зелёный</option>
                <option value="yellow">Жёлтый</option>
                <option value="blue">Синий</option>
              </select>
            </div>
          </div>

          <table class="strategy-table">
            <thead>
            <tr>
              <th>№</th>
              <th>Техника / стратегия</th>
              <th>Переход</th>
              <th>Статус</th>
              <th>Мои переключатели</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in filteredStrategies" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.title }}</td>
              <td>
                <div class="transition-block">
                  <div class="transition-dots">
                      <span
                          v-for="(color, index) in item.fromColors"
                          :key="`${item.id}-${color}-${index}`"
                          class="mini-dot"
                          :style="{ backgroundColor: colorsMap[color] }"
                      ></span>
                  </div>

                  <span class="transition-arrow">→</span>

                  <span
                      class="big-dot"
                      :style="{ backgroundColor: colorsMap[item.toColor] }"
                  ></span>
                </div>
              </td>
              <td>
                  <span v-if="item.used" :class="item.helpful ? 'status-helpful' : 'status-not-helpful'">
                    {{ item.helpful ? 'Помогла' : 'Не помогла' }}
                  </span>
              </td>
              <td>
                <div class="switchers">
                  <div class="icon-button hide-button" @click="toggleHidden(item)">
                    <img v-if="item.hidden" src="@/assets/images/mood_tracker/eye-slash.svg" alt="Иконка зачеркнутого глаза">
                    <img v-else  src="@/assets/images/mood_tracker/eye.svg" alt="Иконка глаза">
                  </div>

                  <div class="icon-button fav-button" @click="toggleSave(item)">
                    <img v-if="item.saved" src="@/assets/images/mood_tracker/heart-filled.svg" alt="Иконка закращенного сердца">
                    <img v-else src="@/assets/images/mood_tracker/heart.svg" alt="Иконка сердца">
                  </div>
                </div>
              </td>
            </tr>

            <tr v-if="!filteredStrategies.length">
              <td colspan="5" class="empty-row">Нет данных</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import Multiselect from "vue-multiselect";
import {onBeforeMount} from "@vue/runtime-core";
import {useStore} from "vuex";

export default {
  name: 'StrategyTable',
  components: {Multiselect},
  setup() {
    const helpfulFilter = ref('all')
    const savedFilter = ref('all')
    const colorFilter = ref('all')

    const colorsMap = {
      red: '#fd0a07',
      yellow: '#fde80c',
      blue: '#183695',
      green: '#6dba33',
    }

    const colorsTranslateMap = {
      red: 'Красный',
      yellow: 'Жёлтый',
      blue: 'Синий',
      green: 'Зелёный',
    };

    const store = useStore();
    const userStrategies = computed(() => store.state.tracker.userStrategies);

    const data = computed(() => {
      return userStrategies.value.map((item) => {
        const currentColorKey = getColorKeyByName(item.target_color.name);

        return {
          id: item.id,
          title: item.text,
          used: item.was_used,
          helpful: item.was_helpful,
          saved: item.is_favourite,
          hidden: item.is_hidden,
          toColor: currentColorKey,
          fromColors: Object.keys(colorsTranslateMap).filter(
              color => color !== currentColorKey
          ),
        }
      })
    });

    const getColorKeyByName = (colorName) => {
      return Object.keys(colorsTranslateMap).find(key => colorsTranslateMap[key] === colorName);
    }

    const filteredStrategies = computed(() => {
      return data.value.filter((item) => {
        const matchesHelpful =
            helpfulFilter.value === 'all' ||
            (helpfulFilter.value === 'helpful' && item.helpful) ||
            (helpfulFilter.value === 'not_helpful' && item.used && !item.helpful)

        const matchesSaved =
            savedFilter.value === 'all' ||
            (savedFilter.value === 'saved' && item.saved) ||
            (savedFilter.value === 'hidden' && item.hidden)

        const matchesColor =
            colorFilter.value === 'all' ||
            item.toColor === colorFilter.value

        return matchesHelpful && matchesSaved && matchesColor
      })
    })

    const fetchStrategies = () => {
      store.dispatch('tracker/getUserStrategies');
    }

    const toggleSave = (item) => {
      store.dispatch('tracker/addStrategyToFavs', {strategy: item.id}).then(() => {
        fetchStrategies();
      });
    }

    const toggleHidden = (item) => {
      store.dispatch('tracker/hideStrategy', {strategy: item.id}).then(() => {
        fetchStrategies();
      });
    }

    onBeforeMount(() => {
      fetchStrategies();
    });

    return {
      helpfulFilter,
      savedFilter,
      colorFilter,
      colorsMap,
      filteredStrategies,
      toggleSave,
      toggleHidden,
    }
  },
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  display: flex;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.strategy-modal {
  position: relative;
  width: 900px;
  max-width: 100%;
  background: #ffffff;
  border-radius: 26px;
  padding: 26px 34px 28px;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  margin: auto 0;
}

.strategy-modal__close {
  position: absolute;
  top: 18px;
  right: 18px;
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #8f8f8f;
  cursor: pointer;
  padding: 0;
}

.strategy-card {
  max-width: 860px;
  overflow-x: auto;
}

.strategy-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 18px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 14px;
  color: #555;
}

.filter-select {
  border: 1px solid #ececec;
  background: white;
  border-radius: 12px;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
}

.strategy-table {
  width: 100%;
  border-collapse: collapse;
}

.strategy-table th,
.strategy-table td {
  text-align: left;
  padding: 12px 10px;
  border-bottom: 1px solid #c9c9c9;
  vertical-align: middle;
  font-size: 14px;
  color: #222;
}

.strategy-table tr:nth-child(even) {
  background: #f8f8f8;
}

.strategy-table th {
  font-weight: 700;
}

.transition-block {
  display: flex;
  align-items: center;
  gap: 10px;
}

.transition-dots {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mini-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.transition-arrow {
  font-size: 18px;
  color: #777;
}

.big-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
}

.switchers {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.icon-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 10px;
  background: white;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.icon-btn.active {
  color: #111;
  background: #ffd7e1;
}

.icon-btn.hiddenState {
  background: #d9d9d9;
  color: #666;
}

.empty-row {
  text-align: center;
  color: #888;
  padding: 24px 0;
}


.icon-button img {
  width: 30px;
  cursor: pointer;
}
</style>